<template>
  <BaseIndex ref="baseIndex" :modelNameSingular="modelNameSingular" :modelNamePlural="modelNamePlural"
    :loading="loading" :pageLoading="pageLoading" :table-headers="tableHeaders" :table-items="mdfes"
    :maskFields="maskFields" :indexErrors="indexErrors" @clear-index-errors="indexErrors = []"
    @options-change="optionsChange" :serverItemsLength="totalItems" :loadOptions="options" :enableCustomFilters="true"
    :containTopToolbar="false" :typeOperators="typeOperators" :serverFields="serverFields"
    @filter-confirm-action="applyFilters" id="nfesPrintTable">

    <template slot="link1" slot-scope="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn text icon link v-on="{ ...tooltip }" :to="'/app/sales?nfeId=' + item.id">
            <v-badge :content="item.cashFlows.length" :value="item.cashFlows.length" color="green" overlap offset-x="8"
              offset-y="8">
              <v-icon>mdi-file-certificate</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Visualizar Venda{{ item.cashFlows.length > 1 ? 's' : '' }}</span>
      </v-tooltip>
    </template>

    <template slot="print">
      <BasePrint printableElementId="nfesPrintTable" printButtonLabel="Imprimir"
        printTitle="Notas fiscais eletrônicas do produtor" @start-printing="printing = loading = true"
        @stop-printing="printing = loading = false" />
    </template>

    <template slot="new" v-if="$route.query.saleId">
      <v-btn @click="redirectToNfes()" class="mt-3">
        Ver todas as NF-es
      </v-btn>
    </template>

    <template v-if="item.canBeReissued" slot="edit" slot-scope="{ item }">
      <Edit :entry="item" @entry-updated="entryUpdated" :modelNameSingular="modelNameSingular" />
    </template>

    <template v-if="$can('update', $router.currentRoute.name) && item.statusKey == 'rejected'" slot="action9" slot-scope="{ item }">
      <!-- Delete was used to cancel the NFe -->
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <!-- Exibe mensagem com erro ou confirmacao -->
    <template v-if="item.nsXmotivo" slot="action1" slot-scope="{ item }">
      <v-tooltip top
        :color="item.statusKey == 'authorized' ? 'success' : item.statusKey == 'canceled' ? 'warning' : 'error'">
        <template v-slot:activator="{ on }">
          <v-icon
            :color="item.statusKey == 'authorized' ? 'success' : item.statusKey == 'canceled' ? 'warning' : 'error'"
            dark v-on="on" class="mx-1">
            {{ item.statusKey == 'authorized' ? 'mdi-file-check' : item.statusKey == 'canceled' ? 'mdi-file-cancel' :
              'mdi-alert' }}
          </v-icon>
        </template>
        <span>{{ item.nsXmotivo }}</span>
      </v-tooltip>
    </template>


    <template
      v-if="$can('update', $router.currentRoute.name) && item.statusKey == 'sending' || item.statusKey == 'waiting_for_response' || item.statusKey == 'retrieving_status_failed'"
      slot="action2" slot-scope="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-icon v-on="{ ...tooltip }" class="mx-1" @click="refreshMdfeStatus(item)">
            mdi-refresh
          </v-icon>
        </template>
        <span>Atualizar Status da emissão da MDF-e</span>
      </v-tooltip>
    </template>

    <template v-if="item.statusKey == 'authorized' || item.statusKey == 'canceled'" slot="action3"
      slot-scope="{ item }">
      <BasePdfViewer v-if="item.statusKey == 'authorized'" :pdfSource="item.pdf" :loading="false"
        :pdfTitle="'MDF-e-' + item.series + '-' + item.number"
        @pdf-open-action="getMdfePdf(item, function () { return null; })" ref="mdfePdfRef" />
      <BasePdfViewer v-if="item.statusKey == 'canceled'" :pdfSource="item.pdf" :loading="false"
        pdfTitle="Danfe de Cancelamento" @pdf-open-action="getNfeCancellationPdf(item, function () { return null; })"
        ref="mdfeCancellationPdfRef" />
    </template>

    <template v-if="item.statusKey == 'authorized' || item.statusKey == 'canceled'" slot="action5"
      slot-scope="{ item }">
      <BaseXmlViewer v-if="item.statusKey == 'authorized'" :xmlSource="item.xml" :loading="false"
        :xmlTitle="'MDF-e-' + item.series + '-' + item.number"
        @xml-open-action="getNfeXml(item, function () { return null; })" ref="mdfeXmlRef" />

      <BaseXmlViewer v-if="item.statusKey == 'canceled'" :xmlSource="item.xml" :loading="false"
        xmlTitle="Danfe XML de Cancelamento"
        @xml-open-action="getNfeCancellationXml(item, function () { return null; })" ref="nfeCancellationXmlRef" />
    </template>

    <!-- v-if="item.travelStatusKey == 'started'" -->
    <template slot="action7" slot-scope="{ item }"
      v-if="item.statusKey == 'authorized' && item.travelStatusKey == 'started'">
      <BasePopup :entry="item" @delete-confirm-action="cancelMdfe(item)" @delete-cancel-action="cancelAction"
        :modelNameSingular="modelNameSingular" :formErrors="formErrors" ref="baseDelete" :deleteIcon="cancelIcon"
        :deleteButtonLabel="cancelButtonLabel" :deleteTitle="cancelTitle"
        :deleteConfirmButtonLabel="cancelConfirmButtonLabel">
        <p> Você tem certeza que deseja cancelar essa MDF-e ?</p>
        <v-textarea v-model="xjust" label="Justificativa" outlined autocomplete="off"></v-textarea>
      </BasePopup>
    </template>

    <template slot="action8" v-if="item.travelStatusKey == 'started' && item.statusKey == 'authorized'" slot-scope="{ item }">
      <BasePopup :entry="item" @delete-confirm-action="closeMdfe(item)" @delete-cancel-action="cancelAction"
        :modelNameSingular="modelNameSingular" :formErrors="formErrors" ref="baseDelete" :deleteIcon="deleteIcon"
        :deleteButtonLabel="deleteButtonLabel" :deleteTitle="deleteTitle" :deleteColor="deleteColor"
        :deleteConfirmButtonLabel="deleteConfirmButtonLabel">
        <p> Você tem certeza que deseja encerrar a viagem ?</p>
      </BasePopup>
    </template>

    <!-- <template slot="action9" slot-scope="{ item }">
      <v-tooltip top color="primary">
        <template v-slot:activator="{ on: tooltip }">
          <v-icon v-on="{ ...tooltip }" class="mx-1" @click="sendNfByEmail(item)" color="primary">
            mdi-email
          </v-icon>
        </template>
        <span>Enviar PDF por e-mail</span>
      </v-tooltip>
    </template> -->


    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="6" class="text-right"><strong class="title mx-3">Total: </strong></td>
        <td colspan="2" class="text-left title"><strong>{{ this.totalPrice | formatCurrency }}</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total:</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.totalPrice | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>

</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import BasePdfViewer from "@shared_components/base_pdf_viewer.vue";
import BaseXmlViewer from "@shared_components/base_xml_viewer.vue";
import BasePrint from "@shared_components/base_print.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import BasePopup from '@shared_components/base_popup.vue';
import Delete from "./delete.vue";

export default {
  data() {
    return {
      mdfes: [],
      xjust: "",
      statusRequests: 0,
      loading: true,
      pageLoading: false,
      indexErrors: [],
      totalPrice: null,
      totalItems: 0,
      formErrors: [],
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Série", align: "left", sortable: true, value: "series" },
        { text: "Número", align: "left", sortable: true, value: "number" },
        // { text: "Emitente", align: "left", sortable: true, value: "tax_payer.name" },
        // { text: "Cliente", align: "left", sortable: true, value: "customer.name" },
        { text: "Motorista", align: "left", sortable: true, value: "carrier.name" },
        { text: "Emitido em", align: "left", sortable: true, value: "issueDate" },
        // { text: "Valor", align: "left", sortable: true, value: "vNf" },
        { text: "Status", align: "left", sortable: true, value: "status", filter_value: "status" },
        { text: "Status Viagem", align: "left", sortable: true, value: "travelStatus", filter_value: "travelStatus" },
        // { text: "Venda", align: "left", sortable: false, value: "link" },
        // { text: "Tipo", align: "left", sortable: false, value: "type" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'issueDate', mask: 'date' },
        { field: 'vNf', mask: 'currency' },
        { field: 'series', mask: 'nfe_serie' },
        { field: 'number', mask: 'nfe_number' },
        { field: 'status', mask: 'status_color', colorField: 'statusColor' },
        { field: 'travelStatus', mask: 'status_color', colorField: 'travelStatusColor' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: [],
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "MDF-e"
    },
    modelNamePlural: {
      type: String,
      default: "MDF-es"
    },
    readIcon: {
      type: String,
      default: "mdi",
    },

    deleteIcon: {
      type: String,
      default: "mdi-truck-check-outline",
    },
    deleteColor: {
      type: String,
      default: "warning"
    },
    deleteButtonLabel: {
      type: String,
      default: function () {
        return "Encerrar";
      }
    },
    deleteTitle: {
      type: String,
      default: function () {
        return "Encerrar MDF-e"
      }
    },
    deleteConfirmButtonLabel: {
      type: String,
      default: "Encerrar"
    },

    cancelIcon: {
      type: String,
      default: "mdi-truck-remove",
    },
    cancelColor: {
      type: String,
      default: "erro"
    },
    cancelButtonLabel: {
      type: String,
      default: function () {
        return "Cancelar";
      }
    },
    cancelTitle: {
      type: String,
      default: function () {
        return "Cancelar MDF-e"
      }
    },
    cancelConfirmButtonLabel: {
      type: String,
      default: "Encerrar"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    BasePdfViewer: BasePdfViewer,
    BaseXmlViewer: BaseXmlViewer,
    BasePrint: BasePrint,
    BasePopup: BasePopup,
  },
  created() {
    // this.loadServerEntries();
  },
  methods: {
    applyFilters: function (filtersList) {
      this.filters = filtersList;
      this.loadServerEntries();
    },
    loadServerEntries: function () {
      let route = this.$route;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_MDFES,
          variables: {
            input: {
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.value),
              filters: this.filters
            },
            // saleId: route.query.saleId ? route.query.saleId : null
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // if (route.query.saleId) {
          //   this.allNfes = response.data.accountContext.nfesIndex.nfes;
          //   this.nfes = _.filter(this.allNfes, function(nfe) {
          //     return nfe.cashFlow.id == route.query.saleId;
          //   });
          // } else {
          this.mdfes = response.data.accountContext.mdfesIndex.mdves;
          // console.log("resp", response.data.accountContext);
          // console.log("mdfes", this.mdfes);

          this.totalItems = response.data.accountContext.mdfesIndex.count;
          this.typeOperators = response.data.accountContext.mdfesIndex.typeOperators;
          this.serverFields = response.data.accountContext.mdfesIndex.serverFields;

          this.totalPrice = 0;
          // for (var mdfe in this.mdfes) {
          //   this.totalPrice += this.mdfes[mdfe].vNf;
          // }
          // this.totalPrice = _.round(this.totalPrice, 2);

          // console.log(this.totalItems, this.typeOperators, this.serverFields)
          // }
          // console.log("All NFEs", this.nfes);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function () {
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("MDF-e reenviada com sucesso!");
    },
    entryCreated: function () {
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("MDF-e enviada com sucesso!");
    },
    entryDeleted: function () {
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("Cancelamento da MDF-e enviado com sucesso!");
    },
    closeMdfe: function (item) {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: CLOSE_MDFE_MUTATION,
          variables: {
            id: item.id,
          }
        })
        .then(response => {
          var errors = response.data.closeMdfe.errors
          if (errors.length) {
            this.formErrors = errors
          } else {
            // this.$emit("entry-destroyed");
            this.$refs.baseDelete.closeDialog();
          }
        })
        .catch(response => console.log(response))
        .finally(() => {
          (this.loading = false);
          this.loadServerEntries();
        }
        );
    },
    cancelMdfe: function (item) {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: CANCEL_MDFE_MUTATION,
          variables: {
            id: item.id,
            xjust: this.xjust,
          }
        })
        .then(response => {
          var errors = response.data.cancelMdfe.errors
          if (errors.length) {
            this.formErrors = errors
          } else {
            // this.$emit("entry-destroyed");
            this.$refs.baseDelete.closeDialog();
          }
        })
        .catch(response => console.log(response))
        .finally(() => {
          (this.loading = false);
          this.loadServerEntries();
        });
    },
    cancelAction: function () {
      this.$refs.baseDelete.closeDialog();
      // this.$emit('entry-canceled');
    },
    redirectToNfes: function () {
      this.$router.push({ name: "OutboundNfe" });
      this.nfes = this.allNfes;
      this.loadServerEntries();
    },
    refreshMdfeStatus: function (mdfe) {
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: UPDATE_MDFE_STATUS_MUTATION,
          variables: {
            input: {
              mdfeId: mdfe.id
            }
          },
        })
        .then(response => {
          //console.log(response.data.retrieveNfpeStatus)
          let errors = response.data.retrieveMdfeStatus.errors;
          if (errors.length) {
            // this.$refs.baseIndex.showErrorMessage(errors);
            this.$set(this, 'indexErrors', errors);
            // this.indexErrors = errors;
          } else {
            var response_mdfe = response.data.retrieveMdfeStatus.mdfe;
            if (response_mdfe) {
              nfe.status = response_mdfe.status;
              nfe.statusKey = response_mdfe.statusKey;
              nfe.nsXmotivo = response_mdfe.nsXmotivo;
            } else {
              this.$set(this, 'indexErrors', ["Não foi possível consultar o status. Tente novamente mais tarde."]);
            }
          }

        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() =>{
         (this.pageLoading = false);
        //  this.$router.push({ name: "OutboundMdfe" });
          this.loadServerEntries();
        });
    },
    downloadMdfePdf: function (nfe, fileName) {
      this.getMdfePdf(nfe, function (pdfFile) {
        const downloadLink = document.createElement("a");
        downloadLink.href = pdfFile;
        downloadLink.download = fileName + '.pdf';
        downloadLink.click();
      });
    },
    getMdfePdf: function (mdfe, callback) {
      if (mdfe.pdf) {
        callback(mdfe.pdf);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_MDFE_PDF_MUTATION,
          variables: {
            mdfeId: mdfe.id
          },
        })
        .then(response => {
          var response_data = "";
          response_data = response.data.downloadMdfePdf;
          var errors = response_data.errors
          // console.log(errors)
          if (errors.length > 0) {
            this.indexErrors = errors;
            this.$refs.mdfePdfRef.closeDialog();
          } else {
            let pdfFile = "data:application/octet-stream;base64," + response_data.mdfe.mdfePdf
            this.$set(mdfe, 'pdf', pdfFile);
            callback(pdfFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfeCancellationPdf: function (mdfe, fileName) {
      this.getNfeCancellationPdf(mdfe, function (pdfFile) {
        const downloadLink = document.createElement("a");
        downloadLink.href = pdfFile;
        downloadLink.download = fileName + '.pdf';
        downloadLink.click();
      });
    },
    getNfeCancellationPdf: function (mdfe, callback) {
      if (mdfe.pdf) {
        callback(mdfe.pdf);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_MDFE_CANCELLATION_PDF_MUTATION,
          variables: {
            mdfeId: mdfe.id
          },
        })
        .then(response => {
          var response_data = "";
          response_data = response.data.downloadMdfeCancellationPdf;
          var errors = response_data.errors
          // console.log(errors)
          if (errors.length > 0) {
            this.indexErrors = errors;
            this.$refs.mdfeCancellationPdfRef.closeDialog();
          } else {
            let pdfFile = "data:application/octet-stream;base64," + response_data.mdfe.mdfeCancellationPdf;
            this.$set(mdfe, 'pdf', pdfFile);
            callback(pdfFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfeXml: function (mdfe, fileName) {
      this.getNfeXml(mdfe, function (xmlString) {
        let bb = new Blob([xmlString], { type: 'text/plain' });
        let xmlFile = window.URL.createObjectURL(bb);
        const downloadLink = document.createElement("a");
        downloadLink.href = xmlFile;
        downloadLink.download = fileName + '.xml';
        downloadLink.click();
      });
    },
    getNfeXml: function (mdfe, callback) {
      // console.log("chamou XML");
      if (mdfe.xml) {
        callback(mdfe.xml);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_MDFE_XML_MUTATION,
          variables: {
            mdfeId: mdfe.id
          },
        })
        .then(response => {
          var errors = response.data.downloadMdfeXml.errors;
          // console.log(errors)
          if (errors.length) {
            this.indexErrors = errors;
            this.$refs.mdfeXmlRef.closeDialog();
          } else {
            let xmlFile = response.data.downloadMdfeXml.mdfe.mdfeXml;
            this.$set(mdfe, 'xml', xmlFile);
            callback(xmlFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfeCancellationXml: function (mdfe, fileName) {
      this.getNfeCancellationXml(mdfe, function (xmlString) {
        let bb = new Blob([xmlString], { type: 'text/plain' });
        let xmlFile = window.URL.createObjectURL(bb);
        const downloadLink = document.createElement("a");
        downloadLink.href = xmlFile;
        downloadLink.download = fileName + '.xml';
        downloadLink.click();
      });
    },
    getNfeCancellationXml: function (mdfe, callback) {
      // console.log("chamou XML");
      if (mdfe.xml) {
        callback(mdfe.xml);
      }
      this.pageLoading = true;
      // console.log("id", mdfe.id);

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_MDFE_CANCELLATION_XML_MUTATION,
          variables: {
            mdfeId: mdfe.id
          },
        })
        .then(response => {
          var errors = response.data.downloadMdfeCancellationXml.errors
          // console.log(errors)
          if (errors.length) {
            this.indexErrors = errors;
            this.$refs.mdfeCancellationXmlRef.closeDialog();
          } else {
            let xmlFile = response.data.downloadMdfeCancellationXml.mdfe.mdfeCancellationXml;
            this.$set(mdfe, 'xml', xmlFile);
            callback(xmlFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    sendNfByEmail: function (mdfe) {
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: SEND_MDFE_BY_EMAIL_MUTATION,
          variables: {
            id: mdfe.id
          },
        })
        .then(response => {
          var errors = response.data.sendNfeByEmail.errors
          // console.log(errors)
          if (errors.length) {
            this.indexErrors = errors;
            // this.$refs.baseIndex.showErrorMessage();
          } else {
            this.$refs.baseIndex.showConfirmationMessage("PDF enviado com sucesso para o seu e-mail.");
          }
        })
        .catch(error => {
          console.log("error", error);
        })
        .finally(() => (this.pageLoading = false));
    },
    optionsChange: function (opts) {
      this.options = opts;
      this.loadServerEntries();
    }
  }
};

// mdfeViewIndexFilters pode ser usado depois !!!
const LOAD_ALL_MDFES = gql`
  query($input: IndexInputObject!) {
  	accountContext {
      mdfesIndex(input: $input) {
        count
        mdves {
          id
          code
          series
          number
          status
          statusKey
          statusValue
          statusText
          statusColor
          carrier{
            id
            name
          }
          travelStatus
          travelStatusKey
          travelStatusValue
          travelStatusText
          travelStatusColor
          
          issueDate
          issueTime
          mailingList
          nsXmotivo
          canBeReissued
        }
        serverFields
        typeOperators
      }
    }
  }
`;

const UPDATE_MDFE_STATUS_MUTATION = gql`
  mutation($input: RetrieveMdfeStatusInputObject!) {
    retrieveMdfeStatus(input: $input) {
      mdfe {
        id
        status
        statusKey
        statusValue
        statusColor
        nsXmotivo
      }
      errors
    }
  }
`;

const DOWNLOAD_MDFE_PDF_MUTATION = gql`
  mutation($mdfeId: ID!){
    downloadMdfePdf(
      input: {
        mdfeId: $mdfeId
    }) {
      mdfe{
        mdfePdf
      }
      errors
    }
  }
`;


const DOWNLOAD_MDFE_XML_MUTATION = gql`
  mutation($mdfeId: ID!){
    downloadMdfeXml(
      input: {
        mdfeId: $mdfeId
    }) {
      mdfe{
        mdfeXml
      }
      errors
    }
  }
`;

const DOWNLOAD_MDFE_CANCELLATION_PDF_MUTATION = gql`
  mutation($mdfeId: ID!){
    downloadMdfeCancellationPdf(
      input: {
        mdfeId: $mdfeId
    }) {
      mdfe{
        mdfeCancellationPdf
      }
      errors
    }
  }
`;

const DOWNLOAD_MDFE_CANCELLATION_XML_MUTATION = gql`
  mutation($mdfeId: ID!){
    downloadMdfeCancellationXml(input: { mdfeId: $mdfeId}) {
      mdfe{
        mdfeCancellationXml
      }
      errors
    }
  }
`;

const CLOSE_MDFE_MUTATION = gql`
  mutation($id: ID!){
    closeMdfe(id: $id) {
      mdfe{
        id
      }
      errors
    }
  }
`;

const CANCEL_MDFE_MUTATION = gql`
  mutation($id: ID!, $xjust: String!){
    cancelMdfe(id: $id, xjust: $xjust) {
      mdfe{
        id
      }
      errors
    }
  }
`;

const SEND_MDFE_BY_EMAIL_MUTATION = gql`
  mutation($id: ID!){
    sendMdfeByEmail(
        id: $id
    ) {
      success
      errors
    }
  }
`;


</script>

<style scoped></style>
